import * as React from 'react';
import {
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   CustomHeading,
   History,
   BulletList,
   OrderedList,
   ListItem,
   HardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   Video,
} from '../extensions';
import { MenuSeparator } from '../components/MenuSeparator';
import { TiptapMenubar } from '../components/TiptapMenubar';
import { TextStyleDropdown } from '../components/TextStyleDropdown';
import { VideoInsertDropdown } from '../components/VideoInsertDropdown';
import {
   BoldButton,
   ItalicButton,
   CodeButton,
   LinkButton,
   UndoButton,
   RedoButton,
   BulletListButton,
   OrderedListButton,
   IndentButton,
   UnindentButton,
} from '../components/buttons';
import type { TiptapExtension } from '.';

export const GuideIntroExtensions: Array<TiptapExtension> = [
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   CustomHeading,
   History,
   BulletList,
   OrderedList,
   ListItem,
   HardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   Video,
];

export const GuideIntroMenuBar = (props: any) => {
   return (
      <TiptapMenubar>
         <BoldButton />
         <ItalicButton />
         <CodeButton />
         <LinkButton />
         <MenuSeparator />
         <TextStyleDropdown />
         <MenuSeparator />
         <BulletListButton />
         <OrderedListButton />
         <UnindentButton />
         <IndentButton />
         <MenuSeparator />
         <VideoInsertDropdown />
         <MenuSeparator />
         <UndoButton />
         <RedoButton />
      </TiptapMenubar>
   );
};
